import React, { useEffect, useState } from "react";

function UpdateButton() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      // Reload otomatis setelah service worker baru aktif
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });

      // Cek apakah ada SW terdaftar
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (!reg) return;
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                // Ada update baru
                setUpdateAvailable(true);
              }
            });
          }
        });
      });
    }
  }, []);

  const handleUpdate = () => {
    navigator.serviceWorker.getRegistration().then((reg) => {
      if (reg?.waiting) {
        reg.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    });
  };

  if (!updateAvailable) return null;

  return (
    <button
      onClick={handleUpdate}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        padding: "10px 16px",
        borderRadius: "8px",
        backgroundColor: "#2563eb",
        color: "white",
        border: "none",
        cursor: "pointer",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        zIndex: 1000,
      }}
    >
      🔄 Update Versi Baru
    </button>
  );
}

export default UpdateButton;
